import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';

// 1. Define the mutation
const mutation = gql`
  mutation incrementGymPlayFriendGamesPlayed($input: IncrementGymPlayFriendGamesPlayedInput!) {
    incrementGymPlayFriendGamesPlayed(input: $input) {
      _id
      userId
      gameType
      opponentName
      played
      won
    }
  }
`;

// 2. Define TypeScript types for input and return shape
export interface IncrementGymPlayFriendGamesPlayedInput {
  opponentName: string;
  gameType: GAME_TYPES_TYPE;
  userId: string;
}

export interface GymPlayFriendGame {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  opponentName: string;
  played: number;
  won: number;
}

export interface MutationType {
  incrementGymPlayFriendGamesPlayed: GymPlayFriendGame;
}

// 3. Create the hook
export function useIncrementGymPlayFriendGamesPlayedMutation(
  options?: MutationHookOptions<MutationType, { input: IncrementGymPlayFriendGamesPlayedInput }>,
) {
  return useMutation<MutationType, { input: IncrementGymPlayFriendGamesPlayedInput }>(
    mutation,
    options,
  );
}
